import { mutatorAction } from 'satcheljs';
import { getConditionalFormattingStore } from '../store/store';
import type { MailboxInfo } from 'owa-client-types';
import type { ConditionalFormattingScenario } from '../store/schema/ConditionalFormattingScenarioType';

// We will want to call this every time the conditional formatting rules change
const clearRowToModificationMapMutator: (
    mailboxInfo: MailboxInfo,
    scenario: ConditionalFormattingScenario
) => void = mutatorAction(
    'clearRowToModificationMap',
    function clearRowToModificationMap(
        mailboxInfo: MailboxInfo,
        scenario: ConditionalFormattingScenario
    ): void {
        getConditionalFormattingStore(mailboxInfo, scenario).rowToModificationsMap.clear();
    }
);
export default clearRowToModificationMapMutator;
